import PropTypes from 'prop-types';
import styles from './TabListItem.module.scss';

const TabListItem = ({ children, selected, onClick, ...props }) => {
    const handleKeypress = evt => {
        if (evt.keyCode === 13 || evt.key === 'Enter') {
            handleClick();
        }
    };

    const handleClick = () => {
        onClick();
    };

    return (
        <li
            className={[styles.listItem, selected ? styles.selected : null].join(' ')}
            role="tab"
            tabIndex={selected ? 0 : -1}
            aria-selected={selected}
            aria-controls={`tab_${children}`.replace(/\s+/g, '-')}
        >
            <a
                className={styles.tab}
                onKeyDown={handleKeypress}
                onClick={handleClick}
                { ...props }
            >
                <span className={styles.content}>{children}</span>
            </a>
        </li>
    );
};

TabListItem.propTypes = {
    children: PropTypes.any,
    selected: PropTypes.bool,
    onClick: PropTypes.func
};

TabListItem.defaultProps = {
    selected: false
};

export default TabListItem;
